var map = {
	"./": 8370,
	"./__mocks__": 8675,
	"./__mocks__/": 8675,
	"./__mocks__/index": 8675,
	"./__mocks__/index.js": 8675,
	"./index": 8370,
	"./index.js": 8370,
	"./react-native/0.57": 5580,
	"./react-native/0.57.js": 5580,
	"./react-native/0.58": 7495,
	"./react-native/0.58.js": 7495,
	"./react-native/0.59": 6555,
	"./react-native/0.59.js": 6555,
	"./react-native/0.60": 6844,
	"./react-native/0.60.js": 6844,
	"./react-native/0.61": 637,
	"./react-native/0.61.js": 637,
	"./react-native/0.62": 3862,
	"./react-native/0.62.js": 3862,
	"./react-native/0.64": 9566,
	"./react-native/0.64.js": 9566,
	"./react-native/0.68": 2538,
	"./react-native/0.68.js": 2538,
	"./react-native/0.69": 4653,
	"./react-native/0.69.js": 4653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2807;